"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formatNumber_1 = require("../../../utility/formatNumber");
function AbsoluteColumn({ rowSpanTags, row, onHover, format, }) {
    return ((0, jsx_runtime_1.jsx)("td", { ...rowSpanTags, ...onHover, children: (0, formatNumber_1.formatNumber)(row.absolute, format) }));
}
exports.default = AbsoluteColumn;
